module.exports = __webpack_public_path__ + "img/sch3-title.8222a496.png";